import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  config: {},
  loading: true,
  error: true,
};

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      const data = action.payload.data || {};
      // Local CRA (4001) should hit local Freezer-Frost API (4002) for new routes like share/create.
      const host = typeof window !== "undefined" ? window.location.hostname : "";
      const useLocalApi = host === "localhost" || host === "127.0.0.1";
      state.config = useLocalApi ? { ...data, API_URL: "http://localhost:4002" } : data;
      // state.config = { ...action.payload.data, API_URL: "http://localhost:4002" };
      state.loading = false;
      state.error = false;
    },
    removeConfig: (state, action) => {
      state.config = {};
      state.loading = true;
      state.error = true;
    },
  },
});

export const { saveConfig, removeConfig } = configSlice.actions;
export default configSlice.reducer;
